import React, {createContext, useCallback, useEffect, useState} from 'react';
import './Popup.css';

// Create a context for the popup
export const PopupContext = createContext();

const Popup = ({isOpen, onClose, isStrict, children, isSizeIndependentAnchor}) => {
    const [showCloseButton, setShowCloseButton] = useState(false);
    const [disableBackgroundClose, setDisableBackgroundClose] = useState(false);
    const [disableEscapeClose, setDisableEscapeClose] = useState(false);
    const [mouseDownOnOverlay, setMouseDownOnOverlay] = useState(false);

    const localOnClose = useCallback(() => {
        console.log('localOnClose');
        setDisableBackgroundClose(false);
        setDisableEscapeClose(false);
        onClose();
    }, [onClose]);

    useEffect(() => {
        if (isOpen) {
            const timer = setTimeout(() => {
                setShowCloseButton(true);
            }, 400);
            return () => clearTimeout(timer);
        } else {
            setShowCloseButton(false);
        }
    }, [isOpen]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape' && !disableEscapeClose) {
                localOnClose();
            }
        };

        if (isOpen) {
            document.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isOpen, localOnClose, disableBackgroundClose]);

    if (!isOpen) {
        return null;
    }

    const handleMouseDown = (e) => {
        if (e.target.classList.contains('popup-overlay')) {
            setMouseDownOnOverlay(true);
        } else {
            setMouseDownOnOverlay(false);
        }
    };

    const handleMouseUp = (e) => {
        if (
            mouseDownOnOverlay &&
            e.target.classList.contains('popup-overlay') &&
            !disableBackgroundClose
        ) {
            localOnClose();
        }
    };

    return (
        <PopupContext.Provider value={{setDisableBackgroundClose, setDisableEscapeClose}}>
            <div
                className={`popup-overlay ${isStrict ? 'strict' : ''}`}
                onMouseDown={handleMouseDown}
                onMouseUp={handleMouseUp}
            >
                <div
                    className={`popup-content ${isStrict ? 'strict' : ''} ${isSizeIndependentAnchor ? 'size-independent-anchor' : ''}`}
                    onClick={(e) => e.stopPropagation()}
                >
                    {showCloseButton && (
                        <button className="generic-close-button" onClick={localOnClose}>
                            ×
                        </button>
                    )}
                    {children}
                </div>
            </div>
        </PopupContext.Provider>
    );
};

export default Popup;
